var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interTF"},[_c('order-search',{ref:"orderSearch",attrs:{"searchColumns":_vm.searchColumns,"searchForm":_vm.searchForm,"columnList":_vm.columnList,"api":_vm.api,"showFooter":1 == 1,"footerTotalCols":_vm.footerTotalCols},on:{"searchCompanyChange":_vm.searchCompanyChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }